import { TOOLPAD_QUERY } from './constants.js';
export default function createQuery(resolver, config) {
    return Object.assign(resolver, {
        [TOOLPAD_QUERY]: config || { parameters: {} },
    });
}
